import { create } from 'zustand'
import { useShallow } from 'zustand/shallow'

export const WEB_SOCKET_DISCONNECT_DEBOUNCE_MS = 15000
export const WEB_SOCKET_RECONNECT_DEBOUNCE_MS = 1500

export type WebSocketConnectionStatus =
  | 'connecting'
  | 'connected'
  | 'disconnected'
  | 'paused'

interface WebSocketConnectionStore {
  isTabVisible: boolean
  status: WebSocketConnectionStatus
  setTabVisible: (isTabVisible: boolean) => void
  setStatus: (status: WebSocketConnectionStatus) => void
}

export const useWebSocketConnectionStatusStore =
  create<WebSocketConnectionStore>((set) => ({
    isTabVisible: true,
    status: 'connecting',
    setTabVisible: (isTabVisible) => {
      set({ isTabVisible })
    },
    setStatus: (status) => {
      set({ status })
    },
  }))

export function useWebSocketConnectionStatus(): {
  isTabVisible: boolean
  status: WebSocketConnectionStatus
} {
  return useWebSocketConnectionStatusStore(
    useShallow((state) => ({
      isTabVisible: state.isTabVisible,
      status: state.status,
    }))
  )
}

export function setWebSocketConnectionStatus(
  status: WebSocketConnectionStatus
): void {
  useWebSocketConnectionStatusStore.getState().setStatus(status)
}

export function setWebSocketTabVisibility(isTabVisible: boolean): void {
  useWebSocketConnectionStatusStore.getState().setTabVisible(isTabVisible)
}
